/* Publish by EComposer at 2026-10-14 21:21:23*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-u36olyuyyl"]=  window.__ectimmers["ecom-u36olyuyyl"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-u36olyuyyl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u36olyuyyl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jh6tlu6xf28').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jh6tlu6xf28', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9l1rum7gyh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9l1rum7gyh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p2g2muu00ge').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p2g2muu00ge', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p9r2ezjkgpi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p9r2ezjkgpi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kzypt5jh76').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kzypt5jh76', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ah3jfm1e6q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ah3jfm1e6q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5mzlscobtd4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5mzlscobtd4', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6k7q2w8bpr9"]=  window.__ectimmers["ecom-6k7q2w8bpr9"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-6k7q2w8bpr9"]["5llk2dml4"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-6k7q2w8bpr9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6k7q2w8bpr9', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-58zqwhz3i9x"]=  window.__ectimmers["ecom-58zqwhz3i9x"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-58zqwhz3i9x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-58zqwhz3i9x', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tllvdpcpd3p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tllvdpcpd3p', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-38t68uflvdb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-38t68uflvdb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sjvvtqp57nh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sjvvtqp57nh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-azyseqzo3t9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-azyseqzo3t9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-offeo9ksozm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-offeo9ksozm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3iht13kmcwi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3iht13kmcwi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k7855qj74fa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k7855qj74fa', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nlazdzlhase').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nlazdzlhase', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mngpfpasr6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mngpfpasr6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z504l0u0ff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z504l0u0ff', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-733vqo88dh9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-733vqo88dh9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-52hyx0c0s2w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-52hyx0c0s2w', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fnp2uririd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fnp2uririd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k5m69draso').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k5m69draso', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-haqh5phub3o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-haqh5phub3o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k70zw4zuy3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k70zw4zuy3', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0e71ajbaxz9p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0e71ajbaxz9p', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ofqsjvy5ek').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ofqsjvy5ek', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kazc3w0o7os').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kazc3w0o7os', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cywgnppqxju').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cywgnppqxju', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xv6r8r5nfj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xv6r8r5nfj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lgtwc5jdrn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lgtwc5jdrn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1nfrory6vxv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1nfrory6vxv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kmhuzhufrkb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kmhuzhufrkb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4jaaqrdxhxx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4jaaqrdxhxx', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-czht55xxt98').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-czht55xxt98', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8vtzkwurxsv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8vtzkwurxsv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}